import {format, isBefore} from 'date-fns';
import {parseCookies} from 'nookies';
import {useMemo} from 'react';
import {
  useAdviserQuestions,
  useOpenQuestions,
} from '../../core/repositories/boxRepository';
import {useUsersMe} from '../../core/repositories/usersMeRepository';
import {validateCookie} from '../../core/usecases/auth/checkOauthTokenExistence';
import {useBoxLocalStorage} from '../box/usecases/useBoxLocalStorage';

export function useViewNewQuestionsAt(): {
  isHaveUnViewAdviserQuestion: boolean;
  isHaveUnViewOpenQuestion: boolean;
  updateViewNewQuestionsAt: () => void;
} {
  const cookies = parseCookies();
  const {isValid} = validateCookie(cookies);

  const {storedValue, updateStoredValue} = useBoxLocalStorage();
  const {data: usersMe} = useUsersMe({
    config: {enabled: isValid},
  });
  const {data: adviserQuestions} = useAdviserQuestions({
    config: {enabled: Boolean(usersMe?.ok)},
    adviserName: usersMe?.ok ? usersMe?.value.adviserUserName : '',
    page: 1,
    limit: 1,
    hasAnswer: 0,
  });
  const {data: openQuestions} = useOpenQuestions({
    config: {enabled: Boolean(usersMe?.ok)},
    page: 1,
    limit: 1,
  });

  const isHaveUnViewAdviserQuestion = useMemo(() => {
    if (
      !storedValue.viewNewQuestionsAt ||
      !adviserQuestions?.ok ||
      adviserQuestions.value.questions.length === 0
    ) {
      return false;
    }

    return isBefore(
      new Date(storedValue.viewNewQuestionsAt),
      new Date(adviserQuestions.value.questions[0]?.createdAt ?? new Date()),
    );
  }, [storedValue, adviserQuestions]);

  const isHaveUnViewOpenQuestion = useMemo(() => {
    if (
      !storedValue.viewNewQuestionsAt ||
      !openQuestions?.ok ||
      openQuestions.value.questions.length === 0
    ) {
      return false;
    }

    return isBefore(
      new Date(storedValue.viewNewQuestionsAt),
      new Date(openQuestions.value.questions[0]?.createdAt ?? new Date()),
    );
  }, [storedValue, openQuestions]);

  const updateViewNewQuestionsAt = () => {
    if (!isValid) {
      return;
    }

    const newDate = format(new Date(), 'yyyy/MM/dd hh:mm:ss zzzz');
    updateStoredValue({viewNewQuestionsAt: newDate});
  };

  return {
    isHaveUnViewAdviserQuestion,
    isHaveUnViewOpenQuestion,
    updateViewNewQuestionsAt,
  };
}
